/**
 * Google Maps API key: prefers Vue CLI env injection; fallback avoids empty client bundle when .env is not picked up.
 * Restrict this key by HTTP referrer in Google Cloud Console.
 */
export const GOOGLE_MAPS_API_KEY = (
  process.env.VUE_APP_GOOGLE_MAPS_API_KEY || 'AIzaSyAyHdEaS8G7BnFXZOq7N0hfDGKeujJypoc'
).trim()
